export const SET_VISIT_DATE = 'SET_VISIT_DATE';
export const SET_VISIT_COMMENTS = 'SET_VISIT_COMMENTS';
export const SET_VISIT_REMINDER_EMAIL = 'SET_VISIT_REMINDER_EMAIL';
export const SET_VEHICLE_MAKE = 'SET_VEHICLE_MAKE';
export const SET_VEHICLE_MODEL = 'SET_VEHICLE_MODEL';
export const SET_VEHICLE_COLOR = 'SET_VEHICLE_COLOR';


// WEBPACK FOOTER //
// ./src/actionTypes/visit.js